import { connect } from 'react-redux';
import Files from './Files';
import { getCitationAuthenticationToken } from '../../../../store/actions/authentication.actions';
import { getCitationFileListLoadingStatus, getCitationFilesList } from '../../../../store/selectors/citation.selectors';
import {
    deleteCitationsFileDocumentBegin,
    downloadCitationsFileDocumentBegin,
} from '../../../../store/actions/citation.actions';

const mapStateToProps = (state: FileList) => {
    const data = getCitationFilesList(state);
    const loading = getCitationFileListLoadingStatus(state);
    return { data, loading };
};
const mapDispatchToProps = {
    deleteFileDocument: deleteCitationsFileDocumentBegin,
    downloadFileDocument: downloadCitationsFileDocumentBegin,
    getAuthenticationToken: getCitationAuthenticationToken,
};
export default connect(mapStateToProps, mapDispatchToProps)(Files);
